import { EUserGrade } from "@models/entity/root";
import http from "@services/axios";

const url: string = "/account/v1/me";

export type TMaritalStatus = "SINGLE" | "MARRIED" | "SEPARATED ";
export type TUserType = "ADMIN" | "THERAPIST" | "CLIENT";

export interface IGetMeDto {
  id: string;
  username: string;
  first_name: string;
  phone_number: string;
  country: string;
  city: string;
  last_name: string;
  email: string;
  region: string;
  user_type: TUserType;
  image: string;
  timezone: string;
  reason_referral?: string;
  marital_status?: TMaritalStatus;
  grade: EUserGrade;
  wallet_balance: number;
}

export const getMe = () =>
  new Promise<IGetMeDto>((resolve, reject) => {
    return http
      .get(url)
      .then(({ data }) => {
        try {
          const result: IGetMeDto = {
            id: data.id,
            username: data.username,
            first_name: data.first_name,
            last_name: data.last_name,
            email: data.email,
            region: data.region,
            user_type: data.user_type,
            image: data.image,
            phone_number: data.phone_number,
            timezone: data.timezone,
            reason_referral: data.reason_referral,
            marital_status: data.marital_status,
            country: data.country,
            city: data.city,
            grade: data.grade,
            wallet_balance: data.wallet_balance,
          };
          resolve(result);
        } catch (error) {
          reject(error);
        }
      })
      .catch((error: any) => {
        reject(error);
      });
  });
